export default {
  'landing.memory': ' خاطرات خود را با ما بسازید',
  'landing.family': 'همراه با خانواده و دوستان خود بهترین سفرها را تجربه کنید',
  'landing.providing':
    'ارائه‌ی تمامی پروازها و ساده‌ترین فرایند جستجو، خرید و استرداد بلیط هواپیما',
  'landing.price': 'پایین‌ترین قیمت خرید بلیط هواپیما با تخفیف ویژه',
  'landing.point': 'با هر سفر امتیاز کسب کنید',
  'landing.buynow': 'همین حالا خرید کنید',
  'landing.scotland': 'به اسکاتلند سفر کنید',
  'landing.ireland': 'به ایرلند سفر کنید',
  'landing.egypt': 'به مصر سفر کنید',
  'landing.greece': 'به یونان سفر کنید',
  'landing.person': 'چندین نفر رفته اند',
  'landing.categories': 'دسته بندی ها',
};
